var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-preview"},[_c('button',{staticClass:"image-preview__close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('CloseLargeIcon')],1),_c('img',{attrs:{"src":_vm.imageUrl,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }